/**
 * The agreement line under customer sign-in, invitation activation and password reset.
 *
 * WORDING IS A DRAFT for Nachi and counsel (legal-redline-change-list-2026-10-14.md). The documents it links are not
 * live yet; see links.ts.
 */
import { CUSTOMER_PRIVACY_URL, CUSTOMER_TERMS_URL } from './links';

export const CustomerLegalNotice = ({ className }: { className?: string }) => (
  <p className={className} data-testid="customer-legal-notice">
    By continuing, you agree to the{' '}
    <a href={CUSTOMER_TERMS_URL} target="_blank" rel="noreferrer">
      Customer Terms of Service
    </a>{' '}
    and acknowledge the{' '}
    <a href={CUSTOMER_PRIVACY_URL} target="_blank" rel="noreferrer">
      Customer Privacy Notice
    </a>
    .
  </p>
);
